import db from '../../js/db'
import * as types from '../mutations-types'
import * as Helpers from '../../js/helpers'
import {
  firestoreAction,
  vuexfireMutations
} from 'vuexfire'

const state = {
  info: {
    settings: {}
  },
  round: {},
  online: {},
  messages: [],
  scartati: {}
}

// getters
const getters = {
  asta_id: state => state.info ? state.info.id : null,
  asta_info: state => state.info,
  asta_round: state => state.round,
  asta_online: state => state.online,
  asta_messages: state => state.messages,
  asta_scartati: state => state.scartati
}

// actions
const actions = {

  // azione speciale che scrive subito
  setAstaInfo({
    commit
  }, _id_asta) {
    return db.getAstaInfo(_id_asta)
      .then(
        (astaInfo) => {
          // add missing props
          const astaInfoSanitized = db.initAstaInfo(_id_asta, astaInfo)
          commit(types.ASTA_SET, astaInfoSanitized);
        }
      )
  },

  setAstaRound({
    commit
  }) {
    return db.getAstaRound()
      .then((round) => {
        commit(types.ROUND_SET, round);
      })
  },

  // altrea azioni standard
  fetchAstaInfo() {
    db.fetchAstaInfo();
  },

  fetchRound({
    state
  }) {
    db.fetchRound()
  },
  fetchOnline({
    state
  }) {
    db.fetchOnline()
  },
  fetchMessages({
    state
  }) {
    db.fetchMessages(() => {})
  },
  fetchScartati({
    state
  }) {
    db.fetchScartati(() => {})
  }
}

// mutations
const mutations = {
  [types.ASTA_SET](state, asta) {
    state.info = asta;
  },
  [types.ASTA_UPD](state, values) {
    for (let k in values) {
      // altrimenti, quando aggiungo nuovi settings in initAstaInfo, verrebbero settati ma cancellati dall'upt 
      if(k == 'settings'){
        for (let j in values[k]) {
            state.info.settings[j] = values[k][j];
          }
      }else{
        state.info[k] = values[k];
      }
    }
  },
  [types.ASTA_CLR](state) {
    state.info = null;
    state.round = {};
  },
  [types.ROUND_SET](state, round) {
    state.round = round;
  },
  [types.ROUND_UPD](state, values) {
    for (let k in values) {
      state.round[k] = values[k];
    }
  },
  [types.ROUND_CLR](state) {
    state.round = {};
  },
  [types.ONLINE_SET](state, online) {
    state.online = online;
  },
  [types.MESSAGES_ADD](state, msg) {
    state.messages.push(msg);
  },
  [types.MESSAGES_SET](state, msgs) {
    state.messages = msgs;
  },
  [types.SETTINGS_UPD](state, values) {
    for (let k in values) {
      state.info.settings[k] = values[k];
    }
  },
  [types.SCARTATI_SET](state, scartati) {
    state.scartati = scartati;
  },
  ...vuexfireMutations
}
// functions


export default {
  state,
  getters,
  actions,
  mutations
}